import { URL_IMAGE } from "edu_lms/constants/type";
import styled from "styled-components";
import img_update from "edu_lms_v2/assets/img/dang_cap_nhap.png";
import { pages } from "edu_lms/components/Seo/meta";
import { PAGE_TRAINING } from "../const";
import thumbPpt from "edu_lms_v2/assets/img/slide_tap_huan_2022.png";
import { DOCUMENT_TYPE_PPT } from "consts/book";

export default function DownloadFile({ item, index, col, page, type }) {
  const downloadFile = (url, is_url) => {
    if (is_url !== "null") {
      window.open(url);
    }
  };

  return (
    <div key={index} className={col}>
      <article
        className="post bg-sh pr"
        style={{ boxShadow: "5px 5px 10px 1px #ccc" }}
      >
        <BookBlocker>
          <a className="post__thumb cursor">
            {page === PAGE_TRAINING && type === DOCUMENT_TYPE_PPT ? (
              <img
                src={thumbPpt}
                alt=""
                onClick={() => downloadFile(item.url, item.is_url)}
              />
            ) : (
              <img
                src={item.is_thumb !== "null" ? item.thumb : img_update}
                alt=""
                onClick={() => downloadFile(item.url, item.is_url)}
              />
            )}
          </a>
        </BookBlocker>

        <div
          className="post__content d-flex justify-content-between"
          style={{
            padding: "16px 10px",
            borderTop: "1px solid #FF7707",
            flex: "1",
          }}
        >
          {page === PAGE_TRAINING && type === DOCUMENT_TYPE_PPT ? (
            <Semester
              title={`${item.worksheet_title} - Slide tập huấn`}
            >{`${item.worksheet_title} - Slide tập huấn`}</Semester>
          ) : (
            <Semester
              title={`${item.worksheet_title}`}
            >{`${item.worksheet_title}`}</Semester>
          )}

          {item.is_url !== "null"}
          <Download
            className="cursor"
            onClick={() => downloadFile(item.url, item.is_url)}
          >
            <i className="fa fa-download" aria-hidden="true"></i>
          </Download>
        </div>
      </article>
    </div>
  );
}

const BookBlocker = styled.div`
  .block {
    position: absolute;
    top: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.7;
    border-radius: 12px 12px 0 0;
    display: none;
    flex-direction: column;
    justify-content: center;
    .label-active {
      line-height: 20px;
      color: #fff;
      font-size: 16px;
      text-align: center;
      padding: 0 15px;
    }
  }

  &:hover .block {
    display: flex;
  }
`;

const Semester = styled.h4`
  padding: 10px 0 0;
  text-transform: none !important;
`;

const Download = styled.a`
  padding-top: 10px;
  i {
    padding: 8px 10px;
    border: 1px solid #ff7707;
    border-radius: 5px;
    color: #ff7707;
    &:hover {
      background-color: #ff7707;
      color: #fff;
    }
  }
`;
